<div class="slider"> <button class="arrow left" (click)="prev()" [disabled]="index === 0"> ◀ </button>
  <div class="viewport">
    <div class="track" [style.transform]="'translateY(-' + (index * itemHeight) + 'px)'">
      <div class="miniatura" *ngFor="let img of imagens" [class.nostock]="!img.estoque" (click)="selecionar(img)"> <img
          [src]="img.src.value" class="img-fluid" [style.opacity]="!img.estoque ? 0.6 : 1" />
        <div class="pre-venda-tag" *ngIf="img.observacao"> {{img.observacao}} </div>
        <div class="descricao"> {{img.descricao}} </div>
      </div>
    </div>
  </div> <button class="arrow right" (click)="next()" [disabled]="imagens && index + visible >= imagens.length"> ▶
  </button>
</div>